import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Youtube32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight32 : s.svgDark32,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
  >
    <path
      d="M16.168 8.5c1.203.006 6.46.05 7.897.431a2.597 2.597 0 011.843 1.823c.407 1.505.433 4.539.435 4.924v.08c-.002.386-.028 3.42-.435 4.924a2.597 2.597 0 01-1.843 1.823c-1.474.391-6.973.428-7.983.431h-.32c-1.01-.003-6.51-.04-7.984-.43a2.597 2.597 0 01-1.843-1.824c-.379-1.4-.428-4.127-.434-4.807v-.313c.006-.68.055-3.407.434-4.808a2.597 2.597 0 011.843-1.823c1.437-.38 6.694-.425 7.897-.43zm-2.668 4v6.187l5.415-3.093L13.5 12.5z"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

export default Youtube32;
